<template>
  <div class="body-content v-application">
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        
      >
        <v-card-text>
         <div class="loadTitle">
        <img :src="images.logo" /> <label>Cargando...</label>
        </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <section class="property" :class="`cantidad_${proyectos.length}`">
      <b-carousel
        :autoplay="autoPlay"
        :icon-pack="iconPack"
        :icon-prev="iconPrev"
        :icon-next="iconNext"
      >
        <v-progress-linear
        indeterminate
        color="yellow darken-2"
        v-show="proyectos.length==0"
      ></v-progress-linear>
        <b-carousel-item v-for="(project, i) in proyectos" :key="i">
          <section class="hero is-medium">
            <div class="has-text-centered">
              <div class="property-container container">
                <div class="property-title">
                  <router-link
                    :to="{ name: 'propiedades' }"
                    class="property-title__btn" v-if="proyectos.length > 1"
                    >Ver Todos</router-link
                  >
                  <h3>
                    <strong>Mi propiedad:</strong
                    >{{ project.productoPrincipal.tipo }}
                    {{ project.productoPrincipal.numero }} -
                    {{ project.proyecto }}
                  </h3>

                  <h3><strong>N° de Negocio:</strong>{{ project.negocio }}</h3>
                </div>
                <div class="property-buttonsGroup">
                  <router-link
                    :to="{
                      name: 'detalle',
                      params: { idNegocio: project.idNegocio },
                    }"
                    ><font-awesome-icon
                      :icon="['fa', 'list']"
                    />Detalles</router-link
                  >
                  <router-link
                    :to="{
                      name: 'estado-compra',
                      params: { idNegocio: project.idNegocio },
                    }"
                    ><font-awesome-icon :icon="['fa', 'home']" />Estado de
                    Compra</router-link
                  >
                  <router-link
                    :to="{
                      name: 'avance-obra',
                      params: { idNegocio: project.idNegocio },
                    }"
                    ><font-awesome-icon
                      :icon="['fa', 'hourglass-half']"
                    />Avance Obra</router-link
                  >
                  <router-link  v-if="project.tieneDocumentos"
                    :to="{
                      name: 'documentos',
                      params: { idNegocio: project.idNegocio },
                    }"
                    ><font-awesome-icon :icon="['fa', 'file']" />Documentos
                    Negocios</router-link
                  >
                  <router-link
                    :to="{
                      name: 'pagos',
                      params: { idNegocio: project.idNegocio },
                    }"
                    ><font-awesome-icon
                      :icon="['fa', 'dollar-sign']"
                    />Pagos</router-link
                  >
                  <router-link  v-if="project.tieneDocumentosPropiedad"
                    :to="{
                      name: 'documentos-propiedad',
                      params: { idNegocio: project.idNegocio },
                    }"
                    ><font-awesome-icon :icon="['fa', 'map']" />Documentos
                    Propiedad</router-link
                  >
                </div>
              </div>
            </div>
          </section>
        </b-carousel-item>
      </b-carousel>
    </section>
    <section class="notification container" v-if="cantidadNotificaciones > 0">
      <div class="notification-container container">
        <div class="notificaion-title">
          <h2>Notificaciones</h2>
          <p>De los últimos 15 días</p>
        </div>
        <div class="notification-group">
          <div class="notification-mobile" v-for="noti in notificaciones.notificaciones" :key="noti.id">
            <div class="notification-item">
              <div class="notification-item__title">
              <h3>
                <span
                  class="bricsa-square"
                  :class="[
                    noti.tipoMensaje == 'Avance' ? 'notiRed' : '',
                    noti.tipoMensaje == 'Cambio estado solicitud'
                      ? 'notiOrange'
                      : '',
                    noti.tipoMensaje == 3 ? 'notiBlue' : '',
                    noti.tipoMensaje == 4 ? 'notiSkiBlue' : '',
                    noti.tipoMensaje == 5 ? 'notiGrey' : '',
                  ]"
                ></span
                >{{ noti.tipoMensaje }}
              </h3>
              <button type="button" @click="updateNotificacion(noti)"
                  v-if="noti.modulo!='' && noti.parametro">Ver
                </button>
                 <button type="button" @click="updateNotificacion(noti)"
                  v-if="noti.modulo!='' && noti.parametro==false"
                  >Ver
                 </button>
              </div>
              <div class="notification-item__info">
                <p>{{ noti.mensaje }}</p>
              </div>
                
                <span v-if="noti.modulo == ''">{{ noti.mensaje }}</span>
              <div class="text-right mr-5">
                <i class="fa fa-envelope" aria-hidden="true" v-show="noti.leida==false"></i>
                <i class="fa fa-envelope-open" aria-hidden="true" v-show="noti.leida"></i>
                </div>
            </div>
          </div>
          <b-carousel-list
            :data="notificaciones.notificaciones"
            :items-to-show="3"
            class="carrusel-desktop"
          >
            <template #item="noti">
              <div class="notification-item" :class="noti.leida?'leida':'no-leida'">
                <div class="notification-item__title">
                <h3>
                  <span
                    class="bricsa-square"
                    :class="[
                      noti.tipoMensaje == 'Avance' ? 'notiRed' : '',
                      noti.tipoMensaje == 'Cambio estado solicitud'
                        ? 'notiOrange'
                        : '',
                      noti.tipoMensaje == 3 ? 'notiBlue' : '',
                      noti.tipoMensaje == 4 ? 'notiSkiBlue' : '',
                      noti.tipoMensaje == 5 ? 'notiGrey' : '',
                    ]"
                  ></span
                  >{{ noti.tipoMensaje }}
                </h3>
                <button type="button" @click="updateNotificacion(noti)"
                  v-if="noti.modulo!='' && noti.parametro">Ver
                </button>
                 <button type="button" @click="updateNotificacion(noti)"
                  v-if="noti.modulo!='' && noti.parametro==false"
                  >Ver
                 </button>
                 </div>
                 <div class="notification-item__info">
                  <p>{{ noti.mensaje }}</p>
                </div>
                 <div class="text-right mr-5">
                <i class="fa fa-envelope" aria-hidden="true" v-show="noti.leida==false"></i>
                <i class="fa fa-envelope-open" aria-hidden="true" v-show="noti.leida"></i>
                </div>
              </div>
            </template>
          </b-carousel-list>
        </div>
      </div>
    </section>
    <section class="adBanner container">
      <img :src="images.family" />
    </section>
    <section class="beneficios container">
      <div class="beneficios-container container">
        <div class="beneficios-group">
          <router-link class="beneficios-item" :to="{ name: 'beneficios' }"
            >Beneficios</router-link
          >
          <router-link class="beneficios-item" :to="{ name: 'novedades' }"
            >Novedades</router-link
          >
          <router-link class="beneficios-item" :to="{ name: 'ayuda' }"
            >Ayuda</router-link
          >
        </div>
      </div>
    </section>
    <section class="destacados container">
      <div class="destacados-container container">
        <div class="destacados-title">
          <h2>Destacados</h2>
        </div>
        <div class="destacados-group">
          <v-progress-linear
            indeterminate
            color="yellow darken-2"
            v-show="destacados.length==0"
          ></v-progress-linear>
          <div
            class="destacados-item"
            v-for="(art, index) in destacados"
            :key="index"
          >
            <img :src="art.img" />
            <div class="destacados-item__info">
              <router-link :to="{ name: 'novedad',params: { name: art.post_name }, }" class="novedades-item"
                ><label>{{ art.post_title }}</label></router-link>
             
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="shortcut">
      <div class="shorcut-group container">
        <div></div>
        <router-link :to="{ name: 'ayuda' }"
          ><font-awesome-icon :icon="['fa', 'phone-alt']" /> Contacto
          ejecutivo</router-link
        >
        <router-link :to="{ name: 'solicitudes' }"
          ><font-awesome-icon :icon="['fa', 'file-alt']" /> Mis
          Solicitudes</router-link
        >
        <div></div>
      </div>
    </section>
    <b-loading
      :is-full-page="isFullPage"
      v-model="isLoading"
      :can-cancel="false"
      ><div class="loadTitle">
        <img :src="images.logo"  /> <label>Cargando...</label>
      </div></b-loading
    >
  </div>
</template>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Ubuntu+Mono:wght@400;700&display=swap");
</style>
<script>
import { mapState } from "vuex";
import moment from "moment";
import { GET_PROJECTS } from "@/core/services/store/proyecto.module";
import { GET_NOTIFICACIONES, UPDATE_NOTIFICACION } from "@/core/services/store/notificacion.module";
import { GET_NOVEDADES } from "@/core/services/store/contenido.module";
moment.locale("es");

export default {
  //mixins: [validationMixin],
  name: "index",
  components: {},
  data() {
    return {
      iconPrev: "chevron-left",
      iconNext: "chevron-right",
      autoPlay: false,
      iconPack: "fa",
      isLoading: true,
      loading: true,
      isFullPage: true,
      perList: 4,
      images: {
                family: process.env.BASE_URL + 'media/family.jpg',
                logo: process.env.BASE_URL +'media/logo.png',
            },
    };
  },
  created() {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 1 * 1);
  },
  mounted() {
    this.getProjects();
    this.getNovedades();
    this.getNotificaciones();
  },
  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    formatTime(value) {
      const hora = moment(value).format("HH:mm:ss");
      return `${hora}`;
    },
  },
  methods: {
    getProjects() {
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECTS, null).then(() => {
        this.$Progress.finish();
        this.loading=false;
      });
    },
    getNovedades() {
      this.$Progress.start();
      this.$store.dispatch(GET_NOVEDADES, null).then(() => {
        this.$Progress.finish();
      });
    },
    getNotificaciones() {
      this.$Progress.start();
      this.$store.dispatch(GET_NOTIFICACIONES, null).then(() => {
        this.$Progress.finish();
      });
    },
    updateNotificacion(notificacion) {
      this.$Progress.start();
      this.$store
          .dispatch(UPDATE_NOTIFICACION, notificacion)
          .then(()=>{
            this.$store.dispatch(GET_NOTIFICACIONES, null).then(() => {
              this.$Progress.finish(),
              this.loading=false;
              if(notificacion.modulo!='' && notificacion.parametro){
                this.$router.push({ name: notificacion.modulo, params: { idNegocio: notificacion.idNegocio } });
              } else if(notificacion.modulo!='' && notificacion.parametro==false){
                this.$router.push({ name: notificacion.modulo });
              }
            });
      });
    }
  },
  computed: {
    ...mapState({
      errors: (state) => state.agreement.errors,
      projects: (state) => state.proyecto.projects,
      novedades: (state) => state.contenido.novedades,
      notificaciones: (state) => state.notificacion.notificaciones,
    }),
    cantidadNotificaciones() {
      if (typeof this.notificaciones.notificaciones == "undefined") return 0;
      return this.notificaciones.notificaciones.length;
    },
    proyectos: function () {
      if (typeof this.projects.proyectos == "undefined") return [];
      console.log(
        "  +++ " +
          typeof this.projects.proyectos +
          " " +
          this.projects.proyectos
      );
      let elementos = this.projects.proyectos;
      elementos.forEach((item) => {
        item.productoPrincipal = item.productos.find((el) => {
          return el.esPrincipal == true ?? {};
        });
      });
      return elementos;
    },
    destacados: function () {
      if (typeof this.novedades.contenidos == "undefined") return {};
      return this.novedades.contenidos.slice(0, 3);
    },
    patenteErrors() {
      const errors = [];
      if (!this.$v.form.patente) return errors;
      !this.$v.form.patente.required && errors.push("Patente es requerido");
      !this.$v.form.patente.patenteEsValido &&
        errors.push("Patente no es válida");
      return errors;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  @media screen and(max-width:1025px) {
    padding: 3% 5% !important;
  }
}
.body-content {
  padding: 0;
  max-width: 1280px;
  margin: auto;
  display: grid;
  grid-template-columns: 100%;
  justify-content: space-between;
  @media screen and(max-width:1025px) {
    padding-top: 120px;
  }
}
.property {
  width: 100%;
  height: fit-content;
  background-color: #f5f5f5;
  .property-container {
    padding: 3% 5% !important;
    display: grid;
    row-gap: 10px;
    -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
    -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
    .property-title {
      .property-title__btn {
        display: flex;
        justify-content: flex-end;
        color: var(--bricsa-red);
      }
      h3 {
        text-align: left;
      }
      strong {
        color: var(--bricsa-red);
        margin-right: 5px;
      }
    }
    .property-buttonsGroup {
    display: grid;
    grid-template-columns: repeat(6, calc(90% / 6));
    justify-content: space-between;
    row-gap: 10px;
    @media screen and(max-width:1025px) {
      grid-template-columns: repeat(3, 32%);
    }
    a {
      padding: 10px 15px;
      text-align: center;
      align-items: center;
      color: #7e7e7e;
      display: grid;
      grid-template-columns: 100%;
      justify-content: center;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      transition: 400ms;
      &:hover {
        background-color: #00457b;
        color: #fff;
      }
      @media screen and(max-width:1024px) {
        font-size: 12px;
      }
      @media screen and(max-width:426px) {
        padding: 5px;
      }
      svg {
        width: 100%;
        height: 30px;
        justify-self: center;
        color: #00457b;
        transition: 400ms;
        &:hover {
          color: #fff;
        }
        @media screen and(max-width:1024px) {
          height: 15px;
        }
      }
    }
  }
  }
}

.property.cantidad_1{
    .carousel {
      .carousel-indicator
      {
        display:none !important;
        visibility: hidden;
      }
    }
  }
.carousel-list.has-shadow {
  -webkit-box-shadow: 0px 0px 0px rgb(0 0 0 / 25%);
  box-shadow: 0px 0px 0px rgb(0 0 0 / 25%);
}
.notification {
  width: 100%;
  padding: 0;
  background: transparent;
  .leida{
        background: #f0f0f0;
        border: 1px solid #ccc;
      }
  .notification-container {
    padding: 10px !important;
    @media screen and(max-width:1024px) {
      padding: 3% 0 !important;
    }
     a, button {
            height: fit-content;
            padding: 1px 15px;
            margin: 10px 10px 0 0;
            font-size: 12px;
            font-weight: bold;
            color: var(--bricsa-red);
            border: solid 2px var(--bricsa-red);
          }
    .notificaion-title {
      h2 {
        color: #707070;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        margin: 10px;
        margin-left: 0;
      }
      p{
        color: #707070;
      }
    }
    .notification-item__title {
          display: flex;
          justify-content: space-between;
          h3 {
            width: -moz-fit-content;
            width: fit-content;
            color: #7e7e7e;
            font-weight: bold;
            text-align: left;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: baseline;
            -ms-flex-align: baseline;
            align-items: baseline;
            margin: 10px 0 0;
            padding-right: 10px;
            span {
              display: block;
              width: 10px;
              height: 10px;
              margin-right: 5px;
              background: var(--bricsa-red);
            }
            .notiRed {
              background-color: var(--bricsa-red);
            }
            .notiOrange {
              background-color: var(--bricsa-orange);
            }
            .notiBlue {
              background-color: var(--bricsa-blue);
            }
            .notiSkiBlue {
              background-color: var(--bricsa-skiblue);
            }
            .notiGrey {
              background-color: var(--bricsa-grey);
            }
          }
          a, button {
            height: fit-content;
            padding: 1px 15px;
            margin: 10px 10px 0 0;
            font-size: 12px;
            font-weight: bold;
            color: var(--bricsa-red);
            border: solid 2px var(--bricsa-red);
          }
        }
        .notification-item__info {
          p {
            padding: 10px;
            color: #7e7e7e;
            font-size: 12px;
            text-align: left;
            overflow: hidden;
            height: calc(1.3rem * 3);
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
    .notification-group {
      display: grid;
      row-gap: 10px;
      .notification-mobile{
        display: none;
        @media screen and(max-width:550px) {
          display: block;
        }
      }
      .carrusel-desktop {
        display: block;
        @media screen and(max-width:550px) {
          display: none;
        }
      }
      .carousel-slides {
        display: grid;
        grid-template-columns: repeat(5, 19.5%);
        justify-content: space-between;
        .carousel-slide {
          width: 100%;
        }
      }
      .notification-item {
        padding: 1px 0;
        -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        h3 {

          width: -moz-fit-content;
          width: fit-content;
          color: #7e7e7e;
          font-weight: bold;
          text-align: left;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: baseline;
          -ms-flex-align: baseline;
          align-items: baseline;
          margin: 10px 0 0;
          padding-right: 10px;
          span {
            display: block;
            width: 10px;
            height: 10px;
            margin-right: 5px;
            background: var(--bricsa-red);
          }
          .notiRed {
            background-color: var(--bricsa-red);
          }
          .notiOrange {
            background-color: var(--bricsa-orange);
          }
          .notiBlue {
            background-color: var(--bricsa-blue);
          }
          .notiSkiBlue {
            background-color: var(--bricsa-skiblue);
          }
          .notiGrey {
            background-color: var(--bricsa-grey);
          }
        }
        p {
          padding: 10px 10px 10px 30px;
          color: #7e7e7e;
          font-size: 12px;
          text-align: left;
          overflow: hidden;
          height: calc(1.3rem * 3);
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          a {
            text-decoration: none;
          }
        }
      }
    }
  }
}
.adBanner {
  width: 100%;
  margin-top: 3%;
  img {
    width: 100%;
    height: 350px;
    object-fit: cover;
    object-position: center 30%;
    @media screen and(max-width:1025px) {
      height: 150px;
    }
  }
}
.beneficios {
  width: 100%;
  .beneficios-container {
    padding: 3% 0 0 !important;
    @media screen and(max-width:1024px) {
    }
    .beneficios-group {
      display: grid;
      grid-template-columns: repeat(3, 32%);
      justify-content: space-between;

      column-gap: 10px;
      .beneficios-item {
        width: 100%;
        padding: 10px 0;
        color: #fff;
        justify-content: center;
        text-align: center;
        background-color: var(--bricsa-skiblue);
        -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      }
    }
  }
}
.destacados {
  width: 100%;
  .destacados-container {
    padding: 3% 0 !important;
    .destacados-title {
      h2 {
        color: #707070;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        margin: 10px;
        margin-left: 0;
      }
    }
    .destacados-group {
      display: grid;
      grid-template-columns: repeat(3, 33%);
      justify-content: space-between;
      row-gap: 10px;
      @media screen and (max-width: 1025px) {
        grid-template-columns: repeat(2, 49%);
      }
      .destacados-item {
        width: 100%;
        height: 200px;
        position: relative;
        display: flex;
        img {
          top: 0;
          left: 0;
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: -1;
        }
        .destacados-item__info {
          width: 100%;
          align-self: flex-end;
          background-color: rgba(0, 0, 0, 0.5);
          padding: 10px;
          display: grid;
          row-gap: 10px;
          label,
          small {
            color: #fff;
          }
          label {
            font-size: 20px;
            font-weight: bold;
            text-align: left;
            overflow: hidden;
            height: calc(2.1rem * 2);
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            @media screen and(max-width:1025px) {
              font-size: 16px;
            }
          }
          small {
            text-align: right;
          }
        }
      }
    }
  }
}
.shortcut {
  padding: 3% 0;
  @media screen and(max-width:1024px) {
    padding: 3% 5%;
  }
  .shorcut-group {
    display: flex;
    justify-content: center;
    row-gap: 5px;
    @media screen and(max-width:1024px) {
      display: grid;
      grid-template-columns: 100%;
      padding: 3% 0 !important;
    }
    a {
      width: 33%;
      display: grid;
      justify-content: center;
      justify-items: center;
      row-gap: 10px;
      padding: 15px 20px;
      margin-right: 20px;
      background-color: var(--bricsa-blue);
      border: none;
      color: #fff;
      font-size: 18px;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      @media screen and(max-width:1024px) {
        width: 100%;
        display: block;
        text-align: center;
        font-size: 14px;
      }
      svg {
        width: 100%;
        height: 30px;
        @media screen and(max-width:426px) {
          margin-right: 5px;
          width: 1.25rem;
          height: 1em;
        }
      }
    }
  }
}
</style>

